import { Link, useSearchParams } from "react-router-dom";
import { useAuth } from "../../auth/AuthProvider";
import { PageHeader } from "../../components/ui";
import type { ServiceType } from "../../data/types";
import { AutomationPipeline } from "./AutomationPipeline";
import { BookingList } from "./BookingList";
import { funnelUrl, serviceFromSlug, serviceNames } from "./shared";

const services: ServiceType[] = ["balloon", "tour", "school"];
const views = [
  {
    id: "ventas",
    label: "Ventas",
    hint: "Consultas y cotizaciones",
  },
  {
    id: "reservas",
    label: "Reservas",
    hint: "Pagos y preparación",
  },
] as const;

/** One place for every customer, from first message to visit. The service is a filter, not a separate section. */
export function FunnelPage() {
  const { hasPermission } = useAuth();
  const [params] = useSearchParams();
  const service = serviceFromSlug(params.get("servicio"));
  const view = params.get("vista") === "reservas" ? "reservas" : "ventas";
  const canSales = hasPermission("crm.read");
  const canBookings =
    hasPermission("bookings.read") || hasPermission("bookings.read_assigned");
  const shown = !canSales && canBookings ? "reservas" : view;
  return (
    <section className="funnel-page">
      <PageHeader
        title="Embudo"
        description="Todos tus clientes, del primer mensaje a la visita."
      />
      <div className="funnel-chips" role="group" aria-label="Servicio">
        {[undefined, ...services].map((item) => (
          <Link
            key={item ?? "all"}
            className="funnel-chip"
            aria-pressed={item === service}
            to={funnelUrl(item, shown)}
            replace
          >
            {item ? serviceNames[item] : "Todos"}
          </Link>
        ))}
      </div>
      {canSales && canBookings && (
        <nav className="workspace-tabs" aria-label="Vistas del embudo">
          {views.map((tab) => (
            <Link
              key={tab.id}
              aria-current={shown === tab.id ? "page" : undefined}
              title={tab.hint}
              to={funnelUrl(service, tab.id)}
              replace
            >
              {tab.label}
            </Link>
          ))}
        </nav>
      )}
      {shown === "ventas" ? (
        <AutomationPipeline
          key={service ?? "all"}
          service={service}
          defaultLayout="board"
        />
      ) : (
        <BookingList key={service ?? "all"} service={service} />
      )}
    </section>
  );
}
